export enum AudioType {
  ALARM,
  ZONE_EVENT
}
